// 监控告警模块
import { acc } from './libs/acc';
import { CustomException } from './error';

// 判断是不是mojo活动
function isMojoProm() {
  return location.pathname.indexOf('/mojo/prom/app_') !== -1 || location.pathname.indexOf('/fmd_mojo/prom/app_') !== -1;
} 

// 告警级别
const LEVEL = {
  '1min_1times': '1min-1times',
  '1min_3times': '1min-3times',
  '1min_6times': '1min-6times',
  '1min_10times': '1min-10times',
  '5min_10times': '5min-10times',
  '5min_25times': '5min-25times',
  '10min_50times': '10min-50times',
};

// 请求告警级别
const REQUEST_LEVEL = {
  '5min_1times': 'drop-5min-1times',
  '15min_1times': 'drop-15min-1times',
  '30min_1times': 'drop-30min-1times',
  '60min_1times': 'drop-60min-1times',
};

const LEVEL_PREFIX = 'alarm'; // 前缀

const JS_ERROR_RETCODE = '1034710000'; // js报错错误码

const ALARM_CONFIG = {
  accModule: 'hkwallet_web',
  // 项目名称
  projectName: '',
  // 告警接收人，多个用户请问逗号隔开
  receiver: '',
  appEnv: 'production',
  replaceCustomException: false,
  listenRequest: false,
  reportClose: false,
};

const EXCEPTION_CONFIG = {
};

const REQUEST_DROP_CONFIG = {
  message: '',
};

const CUSTOM_EXCEPTION_CONFIG = {
  noReportElk: false,
  reportOnce: false,
  noReportAcc: false,
  itilId: '',
};

// 获取server信息
function getServer(cfg, type) {
  if (cfg.customLevel && cfg.customLevel[cfg.name]) {
    return `${LEVEL_PREFIX}-${getLevelName(cfg.customLevel[cfg.name], type)}`;
  } 
  return `${LEVEL_PREFIX}-${getLevelName(cfg.level, type)}`;
}

// 检查是否过滤
function checkExclude(cfg) {
  if (cfg.excludeName) {
    const excludeName = `|${cfg.excludeName.join('|')}|`;
    if (excludeName.indexOf(`|${cfg.name}|`) !== -1) {
      return true;
    }
  }
  if (cfg.excludeRetcode) {
    const excludeRetcode = `|${cfg.excludeRetcode.join('|')}|`;
    if (excludeRetcode.indexOf(`|${cfg.retcode}|`) !== -1) {
      return true;
    }
  }

  if (cfg.excludeFn && typeof cfg.excludeFn === 'function') {
    return excludeFn(cfg.name, cfg.retcode);
  }

  return false;
}

// 检查必填项
function checkError(cfg) {
  if (!cfg.projectName) {
    console.error('alarm projectName不能为空');
  }
  if (!cfg.receiver) {
    console.error('alarm receiver不能为空');
  }
  if (!cfg.name) {
    console.error('alarm name不能为空');
    return true;
  }
}

/**
 * @param {String} val
 * @description 转换磐石告警非法字符
 */
function tansferSensitiveChar(val) {
  return val.replace(/[*%;,"']/g, function (all) {
    return '，';
  });
}

/**
 * @param {String} name
 * @description 获取告警级别
 */
function getLevelName(name, type) {
  if (type === 'requestDrop') {
    return REQUEST_LEVEL[name] || REQUEST_LEVEL['30min_1times'];
  }
  return LEVEL[name] || LEVEL['1min_6times'];
};

/**
 * @param {Object} cfg 配置对象
 * @description 获取retcode
 */
function getRetcode(cfg) {
  if (cfg.retcode) return cfg.retcode;

  const type = Object.prototype.toString.call(cfg.err);

  if (type === '[object String]' && cfg.err) return cfg.err;
  if (type === '[object Object]' && cfg.err.retcode) return cfg.err.retcode;
  if (type === '[object Error]' && cfg.err.data && cfg.err.data.retcode) return cfg.err.data.retcode;

  return JS_ERROR_RETCODE;
};

/**
 * @method getAlarmCfgVal
 * @param {Object} key 配置key
 * @description 获取全局配置值
 */
export function getAlarmCfgVal(key) {
  return ALARM_CONFIG[key];
}

/**
 * @method checkReport
 * @description 在CustomException中判断是否要上报
 */
export function checkReport() {
  return ALARM_CONFIG.projectName && ALARM_CONFIG.receiver && !ALARM_CONFIG.reportClose;
}

/**
 * @method setAlarm
 * @param {Object} alarmCfg https://iwiki.woa.com/pages/viewpage.action?pageId=394803808
 * @description 告警全局配置函数
 */
export function setAlarm(alarmCfg) {
  Object.assign(EXCEPTION_CONFIG, ALARM_CONFIG, alarmCfg, alarmCfg.exception || {});
  Object.assign(REQUEST_DROP_CONFIG, ALARM_CONFIG, alarmCfg, alarmCfg.requestDrop || {});
  Object.assign(CUSTOM_EXCEPTION_CONFIG, ALARM_CONFIG, alarmCfg, alarmCfg.customException || {});
  Object.assign(ALARM_CONFIG, alarmCfg);
}

/**
 * @method alarm
 * @param {Object} alarmCfg https://iwiki.woa.com/pages/viewpage.action?pageId=394803808
 * @param {Object|String} 
 * @description 告警上报函数
 */
export function alarm(alarmCfg) {
  try {
    const cfg = {};

    Object.assign(cfg, EXCEPTION_CONFIG, alarmCfg);
    // if (cfg.appEnv !== 'production') return;
    cfg.retcode = getRetcode(alarmCfg);
    if (checkExclude(cfg)) return;
    // reportElk(cfg);
    if (checkError(cfg)) return;

    const accParam = {
      module: cfg.accModule,
      service: tansferSensitiveChar(cfg.name),
      retcode: cfg.retcode,
      ext1: cfg.projectName ? `${tansferSensitiveChar(cfg.projectName)}` : 'null',
      ext2: cfg.receiver ? `${tansferSensitiveChar(cfg.receiver)}` : 'null',
      ext3: cfg.message ? `${tansferSensitiveChar(cfg.message)}` : 'null',
    };

    if (isMojoProm()) {
      accParam.server = getServer(cfg);
    }

    acc(accParam);

  } catch(e) {

  }
}

/**
 * @method alarmRequestDrop
 * @param {Object} alarmCfg https://iwiki.woa.com/pages/viewpage.action?pageId=394803808
 * @param {Object|String} 
 * @description 告警上报函数
 */
export function alarmRequestDrop(alarmCfg) {
  try {
    const cfg = {};

    Object.assign(cfg, REQUEST_DROP_CONFIG, alarmCfg);
    // if (cfg.appEnv !== 'production') return;
    if (checkExclude(cfg)) return;
    if (checkError(cfg)) return;

    const accParam = {
      module: cfg.accModule,
      service: tansferSensitiveChar(cfg.name),
      retcode: '0',
      ext1: cfg.projectName ? `${tansferSensitiveChar(cfg.projectName)}` : 'null',
      ext2: cfg.receiver ? `${tansferSensitiveChar(cfg.receiver)}` : 'null',
      ext3: cfg.message ? `${encodeURIComponent(tansferSensitiveChar(cfg.message))}` : 'null',
    };

    if (isMojoProm()) {
      accParam.server = getServer(cfg, 'requestDrop');
    }

    acc(accParam);

  } catch(e) {

  }
}


/**
 * 异常类，作用类似CustomException 
 * @param {Object} alarmCfg https://iwiki.woa.com/pages/viewpage.action?pageId=394803808
 */
export class AlarmException extends Error {
  constructor(alarmCfg) {
    super();
    const cfg = {};
    Object.assign(cfg, CUSTOM_EXCEPTION_CONFIG, alarmCfg);
    // if (cfg.appEnv !== 'production') return;
    alarm(cfg);
    return new CustomException(cfg.err, cfg.name, cfg.message, {
      noReportElk: cfg.noReportElk,
      business: cfg.projectName,
      itilId: cfg.itilId,
      reportOnce: cfg.reportOnce,
      noReportAcc: true
    });
  }
}